@switch (context ? context.type : '') {
    @default {
        <fui-edit-textarea-input [control]="control" [disabled]="disabled" #input [label]="label"
                                 [labelI18NParams]="labelI18NParams"
                                 [(ngModel)]="value"
                                 (focussed$)="onFocussed($event)" [notation]="notation" [placeholder]="placeholder">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-edit-textarea-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-textarea-input [disabled]="disabled" #input [(ngModel)]="value" [placeholder]="placeholder"
                                   (focussed$)="onFocussed($event)">
            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
        </fui-filter-textarea-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-textarea-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                   (focussed$)="onFocussed($event)" [placeholder]="placeholder">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-inline-textarea-input>
    }
    @case (contextType.PILL) {
        <fui-textarea-pill [disabled]="disabled" #input [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" [placeholder]="placeholder"></fui-textarea-pill>
    }
}
